import React from "react";
import "./ErpWhatsAppFloat.css";

const WA_URL =
  "https://wa.me/967777926572?text=" +
  encodeURIComponent("مرحباً، أرغب بطلب عرض سعر لنظام ERP / الفوترة الإلكترونية من لايت سوفت.");

const ErpWhatsAppFloat = () => {
  return (
    <a
      className="erp-wa-float"
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل عبر واتساب لطلب عرض سعر"
    >
      واتساب
    </a>
  );
};

export default ErpWhatsAppFloat;
